import React, {Component} from 'react';
import {Col, Row, Button, ControlLabel, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import {prepareSelectOptionsList} from 'util/Utils';
import Select   from 'react-select'
import config from  '../../../../config';
var intervalOptionsList = [
    {label:'Day', value:'day'},
    {label:'Month', value:'month'},
    {label:'Week', value:'week'}
]
var chartsList = [

    {label:'Product Time To Post',  value:'AverageProductTimeToPostForChart', title:'Product Time To Post',

        chartOptions:{  tooltip: {isHtml: true },
        vAxis: {
            title: 'Average product posting time (min)',
        },
        hAxis: {
            title: 'Period',
        }},


    },
    {label:'Posted To Returned',  value:'AverageProductsPostedToReturnedForChart',title:'Posted To Returned', chartOptions:{  tooltip: {isHtml: true },
        vAxis: {
            title: 'Posted To Returned',
        },
        hAxis: {
            title: 'Period',
        }}},
    // {label:'3PL seller products created KPI',  value:'PartnerSellerProductsCreatedForChart', title:'3PL seller products created',
    //
    //     chartOptions:{  tooltip: {isHtml: true },
    //         vAxis: {
    //             title: 'Posted Number',
    //         },
    //         hAxis: {
    //             title: 'Period',
    //         }},
    // },
    // {label:'GBG seller products created KPI',  value:'PartnerPurchasedProductsCreatedForChart', title:'GBG seller products created',
    //     chartOptions:{  tooltip: {isHtml: true },
    //         vAxis: {
    //             title: 'Posted Number',
    //         },
    //         hAxis: {
    //             title: 'Period',
    //         }},
    // },
    // {label:'Posted To Edited',   value:'AverageProductsPostedToEditedForChart',title:'Posted To Edited', chartOptions:{  tooltip: {isHtml: true },
    //     vAxis: {
    //         title: 'Posted To Edited',
    //     },
    //     hAxis: {
    //         title: 'Period',
    //     }}},
    //  {label:'Inventory Price To Orders', value:'InventoryPriceToOrders',title:'Inventory Price To Orders'},
    //  {label:'WG Pickups Completed', value:'CompletedWGPickupsNumber',title:'Total'},
    //  {label:'New and Repeat WG Pickups', value:'RepeatWGPickupsNumber',title:'Total'},
    //   {label:'WG Pickups Repeat', value:'WGPickupsRepeatNumber',title:'Total'}
]
import { fetchAllContractorsList}  from 'shared/sharedMethods';

export default class AdminReportsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var fromDate =moment('01-02-2020', 'MM-DD-YYYY')
        if (!_.isUndefined(this.props.location.query.fromFD)){
            fromDate= moment(this.props.location.query.fromFD)
            if (fromDate.isBefore(moment('01-02-2020', 'MM-DD-YYYY'))){
                fromDate = moment('01-02-2020', 'MM-DD-YYYY')
            }
        }
       var stateData = {
            fromDate:fromDate,
                toDate:_.isUndefined(this.props.location.query.toFD) ? moment()  : moment(this.props.location.query.toFD),
              //  selectedInterval:  {label:'Month', value:'month'},
            chartsToDisplay:[],

        }

        this.state = stateData;
    };

    componentWillReceiveProps(nextProps) {
        if (_.get(nextProps.selectedContractor, 'value','') !== _.get(this.props.selectedContractor, 'value','')) {
            _.forEach(this.state.chartsToDisplay, chartToDisplay => {
                this.props.updateChartData(chartToDisplay)
            })
        }
    }

    getSearchParams( ) {
        var filterOptions = {},errorMessage  = false
         var queryParams = {
         //   addFields : ['createdAt_year'],
        };
        if (_.get(this.props.selectedContractor, 'value')) {
            queryParams.ContractorID = this.props.selectedContractor.value
            queryParams.CreatedBy =_.get(this.props.selectedContractor, 'UserID')
        }
        // if (_.get(this.state.selectedInterval, 'value')) {
        //     queryParams.interval = this.state.selectedInterval.value
        // } else{
        //     errorMessage = {'messageData': {'#1#':  'Interval'}}
        // }

        if (this.state.fromDate &&  moment(this.state.fromDate, 'MM-DD-YYYY',true).isValid()  ) {

            var fromDate = this.state.fromDate.clone();

          //  fromDate.startOf(_.get(this.state.selectedInterval, 'value'))
            queryParams.fromDate =  fromDate.startOf('day').toISOString()
        } else{
            errorMessage = {'messageData': {'#1#':  'From Date'}}
        }

        if (this.state.toDate &&  moment(this.state.toDate, 'MM-DD-YYYY',true).isValid() ) {
            var toDate = this.state.toDate.clone();

         //  toDate.endOf(_.get(this.state.selectedInterval, 'value'))
            queryParams.toDate = toDate.endOf('day').toISOString()
        } else{
            errorMessage = {'messageData': {'#1#':  'To Date'}}
        }

        if (errorMessage) {
            errorMessage = {
                'messageType': 'warning',
                'messageCode': 'errorFieldRequired',
                ...errorMessage
            }
        }

        return {errorMessage, queryParams};
    }

    // _handleKeyPress(e) {
    //     if (e.key === 'Enter') {
    //         this.props.search();
    //     }
    // }



    render() {
          var self = this;
        return (
            <div className="  bot15">
                <Row className="top10">
                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">
                        <ControlLabel>Charts To Display</ControlLabel>
                        <Select
                            placeholder=""
                            multi
                            options={chartsList}
                            onChange={(selectedOptions)=> {
                                var dataToUpdate = {'chartsToDisplay': selectedOptions ? selectedOptions : []}
                                // dataToUpdate.chartsToUpdate = _.filter(this.state.chartsToUpdate, item => {
                                //     return  _.find(dataToUpdate.chartsToDisplay,  chartToDisplay => {
                                //         return chartToDisplay.value == item.value
                                //     })
                                // })
                                if (_.size(dataToUpdate.chartsToDisplay) > _.size(this.state.chartsToDisplay)){/* new chart is selected */
                                    console.log('selectedOptions', selectedOptions,  );
                                    this.props.updateChartData(_.last(selectedOptions))
                                }



                                this.setState(dataToUpdate, function () {
                                    this.props.updateState( )
                                })

                            }}
                            value={self.state.chartsToDisplay}
                        />
                    </Col>
                </Row>

                <Row className="top10" >
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <ControlLabel>From Date</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                  isValidDate={  (date) => {
                                      if (moment(date).isBefore(moment('01-02-2020', 'MM-DD-YYYY'), 'day')) {
                                          return false;
                                      }
                                      return true
                                  }}
                                  onChange={(option) => {
                                      this.setState({
                                          'fromDate':   option,
                                      } );
                                  }}
                                  value={this.state.fromDate}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}  className="top10">
                        <ControlLabel>To Date</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                  isValidDate={  (date) => {
                                      if (moment(date).isBefore(moment('01-02-2020', 'MM-DD-YYYY'), 'day')) {
                                          return false;
                                      }
                                      return true
                                  }}
                                  onChange={(option) => {
                                      this.setState({
                                          'toDate':   option,
                                      } );
                                  }}
                                  value={this.state.toDate}
                        />
                    </Col>

                    {/*<Col xs={9}  sm={4}  md={4} lg={3}   className="top10">*/}
                        {/*<ControlLabel>Interval</ControlLabel>*/}
                        {/*<Select*/}
                            {/*placeholder=""*/}
                            {/*clearable={false}*/}
                            {/*options={intervalOptionsList}*/}
                            {/*onChange={(selectedOption)=> {*/}
                                {/*console.log('selectedOption', selectedOption  );*/}
                                {/*this.setState({*/}
                                    {/*'selectedInterval': selectedOption*/}
                                {/*} );*/}
                            {/*}}*/}
                            {/*value={self.state.selectedInterval}*/}
                        {/*/>*/}
                    {/*</Col>*/}
                </Row>





                {/*<Row className="top20">*/}

                {/*<Col md={4} xs={4} className="pull-right top10">*/}
                    {/*<Button className="pull-right btn btn-primary"*/}
                            {/*disabled={!(_.size(this.state.chartsToUpdate))}*/}
                            {/*onClick={ this.props.updateChartData}>*/}
                        {/*Update Data*/}
                    {/*</Button>*/}
                {/*</Col>*/}
            {/*</Row>*/}


            </div>
        );
    }
}



